export const PASSWORD_VALIDATION_MESSAGE =
  'Password must be at least 8 characters long and include at least 1 upper case letter and 1 number.'

const validPasswordRegex = /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*/=?_.,:;\\-])|(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*/=?_.,:;\\-])|(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*/=?_.,:;\\-])).{8,}$/
export const isPasswordValid = password => {
  return password && password.match(validPasswordRegex)
}

// Same-app relative paths only: rejects absolute, protocol-relative ('//host') and '/\host' URLs
export const isSafeRedirectUrl = url =>
  typeof url === 'string' && url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/\\')
